import { store } from '@/store';
import insurance from '@/utils/insurance';

const terms = {
    /**
     * 取商品條款需要的資料
     * 
     * @param {Array} items - 條款類型
     * @return {Object} 條款api request資料
     */
    termsData(items){
        let termsData = [];
        _.forEach(items, i=>{
            termsData.push({ InsCategory: i.InsCategory, NoteType:i.NoteType, Text:i.Text });
        });
        let insTypes = insurance.getSelectedInsTypes();
        let choice = _.filter(insTypes, function(i){
            return i !== '21';
        });
        if(choice.length > 1 && !insTypes.includes('cmn')){
            insTypes.push('cmn');                
        }
        let insTypesAndDate = {};
        _.forEach(insTypes, i => {
            insTypesAndDate[i] = i === '21' ? store.state.estimate.CompelDateBegin : store.state.estimate.ChoiceDateBegin ;
        });
        termsData.push({ InsCategory: store.state.estimate.InsCategory, NoteType:6, InsTypes: insTypesAndDate, Text: '商品條款'});
        return  termsData;
    }
};

export default terms;